import type { RootState } from '../../reducers';

const selectRawPrice = (state: RootState) => state?.price ?? null;

export default selectRawPrice;
